// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n24Lm7w68CuLRO {
  height: 64px;
  border-top-left-radius: var(--ds-border-radius-200, 8px);
  border-top-right-radius: var(--ds-border-radius-200, 8px);
}
.GLeSppv3KBNz3d .DMbE0hhRjg44Nx,
.ONp29ltvkeROSu .DMbE0hhRjg44Nx {
  overflow-wrap: anywhere;
}
.SieqqIzU_bADac {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  min-height: 40px;
  padding: var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  border-radius: var(--ds-border-radius-200, 8px);
}
.SieqqIzU_bADac .DMbE0hhRjg44Nx,
.SieqqIzU_bADac .ZK1M0AOrX0zQis {
  position: relative;
  z-index: 10;
  align-self: flex-end;
  width: 100%;
  margin-bottom: var(--ds-space-0, 0);
  color: #172b4d;
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 20px;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK {
  padding: var(--ds-space-0, 0);
  overflow: hidden;
  border-top-left-radius: var(--ds-border-radius-200, 8px);
  border-top-right-radius: var(--ds-border-radius-200, 8px);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  -webkit-user-select: none;
          user-select: none;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK .DMbE0hhRjg44Nx,
.SieqqIzU_bADac.TqnNzgE4JS0bHK .ZK1M0AOrX0zQis {
  padding: var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  overflow: visible;
  border-bottom-right-radius: var(--ds-border-radius-200, 8px);
  border-bottom-left-radius: var(--ds-border-radius-200, 8px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #ffffff 100%);
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK .DMbE0hhRjg44Nx::before,
.SieqqIzU_bADac.TqnNzgE4JS0bHK .ZK1M0AOrX0zQis::before {
  content: '';
  position: absolute;
  top: var(--ds-space-negative-400, -32px);
  right: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 32px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 100%);
  mix-blend-mode: normal;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK .ZK1M0AOrX0zQis .DMbE0hhRjg44Nx {
  padding: var(--ds-space-0, 0px);
  background: none;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK .ZK1M0AOrX0zQis .DMbE0hhRjg44Nx::before {
  background: none;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK .ZK1M0AOrX0zQis .SsrdnDEAZmj9of,
.SieqqIzU_bADac.TqnNzgE4JS0bHK .ZK1M0AOrX0zQis .ONp29ltvkeROSu {
  color: #172b4d;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .DMbE0hhRjg44Nx,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .ZK1M0AOrX0zQis {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%);
  color: #ffffff;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .DMbE0hhRjg44Nx::before,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .ZK1M0AOrX0zQis::before {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  mix-blend-mode: normal;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .DMbE0hhRjg44Nx .DMbE0hhRjg44Nx,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .ZK1M0AOrX0zQis .DMbE0hhRjg44Nx {
  background: none;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .DMbE0hhRjg44Nx .DMbE0hhRjg44Nx::before,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .ZK1M0AOrX0zQis .DMbE0hhRjg44Nx::before {
  background: none;
}
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .DMbE0hhRjg44Nx .SsrdnDEAZmj9of,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .ZK1M0AOrX0zQis .SsrdnDEAZmj9of,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .DMbE0hhRjg44Nx .ONp29ltvkeROSu,
.SieqqIzU_bADac.TqnNzgE4JS0bHK.WjzBu3zSKL2VlE .ZK1M0AOrX0zQis .ONp29ltvkeROSu {
  color: #ffffff;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.GLOH1coj4lHm_u {
  position: relative;
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.GLOH1coj4lHm_u .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.GLOH1coj4lHm_u .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.GLOH1coj4lHm_u::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.FMuVxuq12OB0AZ {
  position: relative;
  background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.FMuVxuq12OB0AZ .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.FMuVxuq12OB0AZ .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.FMuVxuq12OB0AZ::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.iG5QaW2aCR3Azr {
  position: relative;
  background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.iG5QaW2aCR3Azr .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.iG5QaW2aCR3Azr .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.iG5QaW2aCR3Azr::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.t2EY7y4Xu9IL8m {
  position: relative;
  background-color: var(--ds-background-accent-red-subtle, #f87462);
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.t2EY7y4Xu9IL8m .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.t2EY7y4Xu9IL8m .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.t2EY7y4Xu9IL8m::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.Q1dyx15B4fCdcW {
  position: relative;
  background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.Q1dyx15B4fCdcW .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.Q1dyx15B4fCdcW .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.Q1dyx15B4fCdcW::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.C6hu8thW19Gcb3 {
  position: relative;
  background-color: var(--ds-background-accent-blue-subtle, #579dff);
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.C6hu8thW19Gcb3 .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.C6hu8thW19Gcb3 .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.C6hu8thW19Gcb3::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.AXr4OWtg1kZ72L {
  position: relative;
  background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.AXr4OWtg1kZ72L .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.AXr4OWtg1kZ72L .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.AXr4OWtg1kZ72L::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.JTlTpQ4fc6JyoM {
  position: relative;
  background-color: var(--ds-background-accent-lime-subtle, #94c748);
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.JTlTpQ4fc6JyoM .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.JTlTpQ4fc6JyoM .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.JTlTpQ4fc6JyoM::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.lJKZLVarCovBUU {
  position: relative;
  background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.lJKZLVarCovBUU .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.lJKZLVarCovBUU .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.lJKZLVarCovBUU::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.aZIwLpudavAeVy {
  position: relative;
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.aZIwLpudavAeVy .DMbE0hhRjg44Nx {
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.SieqqIzU_bADac.eSIkt5u4JZyHet.aZIwLpudavAeVy .GLeSppv3KBNz3d {
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac.eSIkt5u4JZyHet.aZIwLpudavAeVy::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  mask-repeat: repeat-y;
}
.SieqqIzU_bADac.eSIkt5u4JZyHet .GLeSppv3KBNz3d {
  display: flex;
}
.SieqqIzU_bADac.mGSYii95UkYs4q {
  min-height: 108px;
}
.body-color-blind-mode-enabled  .eSIkt5u4JZyHet > .DMbE0hhRjg44Nx {
  left: var(--ds-space-200, 16px);
  width: calc(100% - 16px);
}
.body-color-blind-mode-enabled  .UqzSbPVmRqpOQv {
  display: flex;
  position: relative;
  left: var(--ds-space-200, 16px);
  align-items: flex-start;
  width: calc(100% - 16px);
}
.body-color-blind-mode-enabled .SieqqIzU_bADac::before {
  border-top-left-radius: var(--ds-border-radius-200, 8px);
  border-bottom-left-radius: var(--ds-border-radius-200, 8px);
}
`, ""]);
// Exports
export var emptyCover = `n24Lm7w68CuLRO`;
export var completeColorCoverChildrenName = `GLeSppv3KBNz3d`;
export var name = `DMbE0hhRjg44Nx`;
export var completeImageCoverChildrenName = `ONp29ltvkeROSu`;
export var fullCover = `SieqqIzU_bADac`;
export var doneState = `ZK1M0AOrX0zQis`;
export var cardFrontImageCover = `TqnNzgE4JS0bHK`;
export var imageCoverButton = `SsrdnDEAZmj9of`;
export var darkGradient = `WjzBu3zSKL2VlE`;
export var cardFrontColorCover = `eSIkt5u4JZyHet`;
export var green = `GLOH1coj4lHm_u`;
export var yellow = `FMuVxuq12OB0AZ`;
export var orange = `iG5QaW2aCR3Azr`;
export var red = `t2EY7y4Xu9IL8m`;
export var purple = `Q1dyx15B4fCdcW`;
export var blue = `C6hu8thW19Gcb3`;
export var sky = `AXr4OWtg1kZ72L`;
export var lime = `JTlTpQ4fc6JyoM`;
export var pink = `lJKZLVarCovBUU`;
export var black = `aZIwLpudavAeVy`;
export var hasStickers = `mGSYii95UkYs4q`;
export var completeColorCoverContainerName = `UqzSbPVmRqpOQv`;
export default ___CSS_LOADER_EXPORT___;
